import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import UserRoles from "constants/UserRoles";

class Stats extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.FieldEngineer, UserRoles.Developer, UserRoles.HelpDesk];

	render() {
		let {
			history,
		} = this.props;

		return (
			<div>
				<Framework.Components.PageBar history={history}/>

				<Objects.EngineerStats
					history={this.props.history}
					currentFE={this.props.currentFE}
					id={this.props.user}
				/>
			</div>
		)
	}
}
export default Framework.Components.withRootState(Stats);




